<template>
<Sidebar v-model:visible="$store.state.ui.filtertemplatessidebar" header="Sidebar" position="right" class="w-full md:w-6 lg:w-6">

<div class="grid-nogutter flex justify-content-between">
<div class="col-6"><h3 class="text-primary mt-1">{{headerlabel}}</h3></div>
<div class="col-fixed flex-column  align-items-end">
<Button v-if="show_new_button" :label="$store.state.languages.lang_phrases.mevcut_filtreyi_kaydet" class="p-button-success p-button-outlined  p-button-sm mr-2"  icon="pi pi-plus" @click="showNewFilterForm" ></Button>
</div>
</div>


<div class="slide_container">
<div class="tabs_container animate_class_short"  :class="tabs_container_class">

<PlannerTableTemplateSidebarTabs 
ref="tabs"
@applyFilter="applyFilter"
/>
</div>


<div class="form_container animate_class_short" :class="form_container_class">

<PlannerTableTemplateSidebarForm 
@hideNewFilterForm="hideNewFilterForm"
:schema="schema"
:customattributefilters="customattributefilters"
:brand_columns="brand_columns"
:pagetype="pagetype"
/>
</div>


</div>












</Sidebar>
</template>

<script>
import PlannerTableTemplateSidebarTabs from "./PlannerTableTemplateSidebarTabs"
import PlannerTableTemplateSidebarForm from "./PlannerTableTemplateSidebarForm"
export default {

  name: 'PlannerTableTemplateSidebar',
  props:["schema","customattributefilters","brand_columns","pagetype"],
  data () {
    return {
    	loading:true,
      show_form:false,
    }
  },
  components:{PlannerTableTemplateSidebarTabs,PlannerTableTemplateSidebarForm},
  computed:{
    headerlabel()
    {
      if(this.show_form)
      {
        return this.$store.state.languages.lang_phrases.yeni_sablon
      }
      return this.$store.state.languages.lang_phrases.filtre_sablonlari
    },
    show_new_button()
    {
      if(this.show_form)
      {
        return false
      }
      return true
    },
  	filtertemplatessidebar()
  	{
  		return this.$store.state.ui.filtertemplatessidebar
  	},
    tabs_container_class()
    {
      if(this.show_form)
      {
        return "tabs_container_hide"
      }
      return null
    },
    form_container_class()
    {
      if(this.show_form)
      {
        return "form_container_show"
      }
      return null      
    },
  },
  watch:{
  	filtertemplatessidebar()
  	{
  		if(this.filtertemplatessidebar)
  		{
  			this.getData()
  		}
      else
      {
        this.show_form = false
      }
  	}
  },
  methods:{
    applyFilter(filter)
    {
      this.$emit("applyFilter",filter)
      this.$store.dispatch('ui/setFilterTemplatesSidebar',false)
    },
  	async getData()
  	{
  		this.loading = true
      console.log(this.schema)
      console.log(this.customattributefilters)
      console.log(this.brand_columns)

      setTimeout(()=>{
        this.$refs.tabs.showUserFilters()
      },100)
  		setTimeout(()=>{
  			this.loading = false
  		},2000)

  	},
    showNewFilterForm()
    {
      this.show_form = true
    },
    hideNewFilterForm()
    {
      this.show_form = false
      this.getData()
    },
  }
}
</script>

<style lang="css" scoped>
  .slide_container{
    position: relative;
    width: 100%;
    height: 80vh;
    overflow-x: hidden;
  }
  .tabs_container{
    width: 100%;
    position: absolute;
    left: 0;
  }
  .tabs_container_hide{
    left: -100%;
  }
  .form_container{
    width: 100%;
    position: absolute;
    left: 100%;
  }
  .form_container_show{
    left: 0;
  }
</style>